var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import hoistNonReactStatics from 'hoist-non-react-statics';
import { injectIntl as actualInjectIntl } from 'react-intl';
/* eslint-disable react/prefer-stateless-function, eqeqeq */
var injectFakeIntl = function (WrappedComponent) {
    var IntlInjector = /** @class */ (function (_super) {
        __extends(IntlInjector, _super);
        function IntlInjector() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        IntlInjector.prototype.render = function () {
            return (_jsx(WrappedComponent, __assign({ intl: { formatMessage: function () { return null; } } }, this.props)));
        };
        IntlInjector.WrappedComponent = WrappedComponent;
        IntlInjector.displayName = "IntlInjector(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
        return IntlInjector;
    }(React.Component));
    return hoistNonReactStatics(IntlInjector, WrappedComponent);
};
export var injectIntl = process.env.NODE_ENV === 'test' ? injectFakeIntl : actualInjectIntl;
export default injectIntl;
